import "./App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import SignIn from "./pages/SignIn";
import EmployeeApp from "./pages/EmployeeApp";
import Dashboard from "./pages/Dashboard";
import TrademarkBadge from "./components/TrademarkBadge";
import SyncIndicator from "./components/SyncIndicator";
import Splash from "./components/Splash";
import PreviewBanner from "./components/PreviewBanner";
import { Toaster } from "./components/ui/sonner";
import { bootstrap } from "./lib/sync";
import { migrateUserPins, optimizeStoredProductImages } from "./lib/storage";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        await bootstrap();
        const imageResult = await optimizeStoredProductImages();
        if (imageResult.changed > 0) {
          console.info(
            `[storage] optimized ${imageResult.changed} product image(s), reclaimed ~${Math.round(imageResult.savedBytes / 1024)} KB`
          );
        }
        await migrateUserPins();
      } catch (e) {
        console.warn("[app] startup maintenance skipped", e);
      } finally {
        if (active) setReady(true);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  if (!ready) {
    return <Splash />;
  }

  return (
    <LanguageProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/main" element={<Dashboard role="main" />} />
          <Route path="/manager" element={<Dashboard role="restaurant" />} />
          <Route path="/employee" element={<EmployeeApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <SyncIndicator />
      <TrademarkBadge />
      <PreviewBanner />
      <Toaster position="top-center" />
    </div>
    </LanguageProvider>
  );
}

export default App;
